export const GET_USER = 'GET_USER';
export const GET_SETTINGS = 'GET_SETTINGS';
export const EDIT_USER = 'PUT_SETTINGS';
export const EDIT_SETTINGS = 'EDIT_SETTINGS';
export const LOADING_SETTINGS = 'LOADING_SETTINGS';
export const SETTINGS_ERROR = 'SETTINGS_ERROR';
